import type { Invitation } from "@/types/invitation";

// Best-effort display string for a pending invite row in the admin members
// list. Prefers the identifier the inviter actually used, falls back to any
// other field the invitee had on their user doc at invite time, and finally
// to a generic placeholder for legacy docs (pre-multi-identifier).
export const formatInviteeIdentifier = (
  invitation: Pick<
    Invitation,
    | "inviteeIdentifierType"
    | "inviteeEmail"
    | "inviteeUsername"
    | "inviteePhone"
  >,
  fallback: string,
): string => {
  const { inviteeIdentifierType, inviteeEmail, inviteeUsername, inviteePhone } =
    invitation;

  const email = inviteeEmail ?? undefined;
  const username = inviteeUsername ?? undefined;
  const phone = inviteePhone ?? undefined;

  const formatPhone = (p: { prefix: string; number: string }) =>
    `${p.prefix} ${p.number}`;
  const formatUsername = (u: string) => `@${u}`;

  if (inviteeIdentifierType === "username" && username)
    return formatUsername(username);
  if (inviteeIdentifierType === "phone" && phone) return formatPhone(phone);
  if (inviteeIdentifierType === "email" && email) return email;

  if (email) return email;
  if (username) return formatUsername(username);
  if (phone) return formatPhone(phone);
  return fallback;
};
